import {
  EXPENSES_ALL,
  EXPENSES_MERGE,
  EXPENSES_GET,
  EXPENSES_DEL,
  EXPENSES_PUT,
  EXPENSES_POST,
  EXPENSES_LOADING,
  EXPENSES_ERROR,
  EXPENSES_RESET,
  EXPENSES_PENDING_COUNT,
  EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT,
  EXPENSES_REVIEW_PENDING_COUNT,
} from '../types';

import api from '../../../utils/functions/api';

export const expensesCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses`,
      payload,
    );
    dispatch({ type: EXPENSES_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesCreateWithOutNotify = (payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/won`,
      payload,
    );
    dispatch({ type: EXPENSES_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesAll = (params) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const {
      name = '',
      size = 99999,
      page = 1,
      me = '',
      search = '',
      findProject = '',
      dateStart: dateStartParam = '',
      dateEnd: dateEndParam = '',
      status: statusFilter = '',
      statuses: statusesFilter = '',
      paymentApprovalStatuses = '',
      reviewStatuses = '',
      sortBy = '',
      sortDir = '',
      readyDateStart: readyDateStartParam = '',
      readyDateEnd: readyDateEndParam = '',
      urgentQueue = '',
      urgentSuccessStart: urgentSuccessStartParam = '',
      urgentSuccessEnd: urgentSuccessEndParam = '',
      dueToday = '',
    } = params;
    const dateStart = dateStartParam instanceof Date ? dateStartParam.toISOString() : dateStartParam;
    const dateEnd = dateEndParam instanceof Date ? dateEndParam.toISOString() : dateEndParam;
    const toIso = (v) => (v instanceof Date ? v.toISOString() : v);
    const readyDateStart = toIso(readyDateStartParam);
    const readyDateEnd = toIso(readyDateEndParam);
    const urgentSuccessStart = toIso(urgentSuccessStartParam);
    const urgentSuccessEnd = toIso(urgentSuccessEndParam);
    const q = new URLSearchParams({ name, size, page, me, search, findProject });
    if (dateStart) q.set('dateStart', dateStart);
    if (dateEnd) q.set('dateEnd', dateEnd);
    if (statusFilter) q.set('status', statusFilter);
    if (statusesFilter) q.set('statuses', statusesFilter);
    if (paymentApprovalStatuses) q.set('paymentApprovalStatuses', paymentApprovalStatuses);
    if (reviewStatuses) q.set('reviewStatuses', reviewStatuses);
    if (sortBy) q.set('sortBy', sortBy);
    if (sortDir) q.set('sortDir', sortDir);
    if (readyDateStart) q.set('readyDateStart', readyDateStart);
    if (readyDateEnd) q.set('readyDateEnd', readyDateEnd);
    if (urgentQueue) q.set('urgentQueue', urgentQueue);
    if (urgentSuccessStart) q.set('urgentSuccessStart', urgentSuccessStart);
    if (urgentSuccessEnd) q.set('urgentSuccessEnd', urgentSuccessEnd);
    if (dueToday) q.set('dueToday', dueToday);
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses?${q.toString()}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
  }
};

// ดึงรายการเบิกตามเงื่อนไข (เช่น statuses / dateStart–dateEnd) ทีละหน้าจน "ครบทุกแถวที่ตรงเงื่อนไข" แล้วรวมเป็น
// ก้อนเดียว — ใช้แทนการขอ size ใหญ่ๆ ครั้งเดียว (ขอเกิน ~2,000 แถวแล้ว backend พังด้วยขีดจำกัด 16MB ของ MongoDB)
// ต้องมีเงื่อนไขกรองที่ทำให้ผลลัพธ์ไม่ใหญ่เกินไปเสมอ ไม่ใช่ดึงทั้งระบบ
const PAGED_FETCH_SIZE = 500;
export const fetchExpensesPaged = async (params = {}) => {
  const rows = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const q = new URLSearchParams({ ...params, size: PAGED_FETCH_SIZE, page });
    // eslint-disable-next-line no-await-in-loop
    const { data } = await api.get(`${process.env.REACT_APP_API_URL}/expenses?${q.toString()}`);
    const got = data?.rows || [];
    total = data?.total ?? total;
    rows.push(...got);
    if (got.length < PAGED_FETCH_SIZE || rows.length >= total) break;
    page += 1;
  }
  return { rows, total: rows.length };
};

export const expensesAllPaged = (params) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const data = await fetchExpensesPaged(params);
    dispatch({ type: EXPENSES_ALL, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    return { rows: [], total: 0 };
  }
};

export const expensesMergeRows = (rows) => ({ type: EXPENSES_MERGE, payload: rows || [] });

// ดึงเฉพาะรายการเบิกที่ระบุ id แล้วเติมเข้า state.expenses.rows (ไม่ทับของเดิม) — แบ่งส่งทีละ 100 id
export const expensesMergeByIds = (ids) => async (dispatch) => {
  const unique = [...new Set((ids || []).map(String).filter(Boolean))];
  const CHUNK = 100;
  try {
    for (let i = 0; i < unique.length; i += CHUNK) {
      const chunk = unique.slice(i, i + CHUNK);
      const q = new URLSearchParams({ ids: chunk.join(','), size: chunk.length, page: 1 });
      // eslint-disable-next-line no-await-in-loop
      const { data } = await api.get(`${process.env.REACT_APP_API_URL}/expenses?${q.toString()}`);
      dispatch({ type: EXPENSES_MERGE, payload: data?.rows || [] });
    }
  } catch (error) {
    console.error(error);
  }
};

export const expensesGetDaily = (params) => async (dispatch) => {
  try {
    const { date = '', dateStart = '', dateEnd = '' } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses/daily/report?date=${date}&dateStart=${dateStart}&dateEnd=${dateEnd}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
    );
    if (status === 200) {
      dispatch({ type: EXPENSES_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesPut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
      payload,
    );
    dispatch({ type: EXPENSES_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};
// sync ยอดค่าแรงต่อโครงการ (จาก TimestampProjectCost.js) เข้า Expenses แบบ draft (isLabor) ระหว่างยังไม่กด
// บันทึกเงินเดือน — ไม่ผูกกับ EXPENSES_* redux slice เลย (HrReportV2 ไม่ได้อ่าน state.expenses)
export const laborDraftSync = (payload) => async () => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/labor-draft-sync`,
      payload,
    );
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// เช็คก่อนกดบันทึกเงินเดือนจริง (dry-run) — หาโครงการที่มีรายการเบิกค่าแรงงวดนี้ที่อนุมัติ/ดำเนินการไปแล้ว
// (ระบบไม่แตะยอดซ้ำ) แต่ยอดในตารางตอนนี้ต่างจากยอดที่อนุมัติค้างไว้ — ใช้เตือน HR ก่อนบันทึก (HrReportV2.js
// onSubmit) คืน [] ถ้าเรียกไม่สำเร็จ (ไม่บล็อกการบันทึกเงินเดือนเพราะ endpoint นี้ล้ม)
export const checkLaborDraftConflicts = (payload) => async () => {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/labor-draft-conflicts`,
      payload,
    );
    return data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

// ปุ่ม "รีเซ็ต" ในแท็บ "ตั้งเบิกค่าแรง" — ลบรายการค่าแรงทิ้ง 1 รายการ (เฉพาะที่ยัง PENDING/LABOR_DRAFT)
// แล้ว backend สร้างใหม่จาก snapshot ที่บันทึกเงินเดือนไว้ของงวดเดียวกัน (SalaryList.dashboard) ในคำขอเดียว
// คืน { recreated, id, project_id, labor_period_start, labor_period_end, labor_emp_type } — recreated:false
// = ไม่พบ snapshot (งวดยังไม่บันทึกเงินเดือน) ผู้เรียกควรแจ้งผู้ใช้ให้บันทึกเงินเดือนงวดนั้นก่อน
export const resetLaborExpense = (id) => async () => {
  const { data } = await api.delete(
    `${process.env.REACT_APP_API_URL}/expenses/${id}/labor-reset`,
  );
  return data;
};

// หน้า "อนุมัติการจ่ายเงิน" (Profile) — action: 'APPROVE' | 'REJECT' | 'HOLD'
export const expensesSetPaymentApproval = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/expenses/${id}/payment-approval`,
      payload,
    );
    dispatch({ type: EXPENSES_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw error;
  }
};

// หน้า "ตรวจสอบรายการเบิกเงิน" (Profile) — action: 'REVIEW' | 'FLAG' | 'HOLD'
export const expensesSetReviewStatus = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/expenses/${id}/review-status`,
      payload,
    );
    dispatch({ type: EXPENSES_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw error;
  }
};

// toggle "ด่วน" — จาก modal รายละเอียดรายการเบิกจ่าย (ExpensesDetail.js) — สลับ is_urgent เข้า/ออก
export const expensesToggleUrgent = (id) => async (dispatch) => {
  try {
    const { data } = await api.patch(
      `${process.env.REACT_APP_API_URL}/expenses/${id}/urgent`,
    );
    dispatch({ type: EXPENSES_PUT, payload: data });
    return data;
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw error;
  }
};

export const expensesDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/expenses/${id}`,
    );
    dispatch({ type: EXPENSES_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesAddImages = (expensesId, imageIds) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    await api.post(
      `${process.env.REACT_APP_API_URL}/expenses/${expensesId}/images`,
      { imageIds },
    );
    dispatch({ type: EXPENSES_PUT, payload: {} });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesRemoveImage = (expensesId, imageId) => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_LOADING });
    await api.delete(
      `${process.env.REACT_APP_API_URL}/expenses/${expensesId}/images/${imageId}`,
    );
    dispatch({ type: EXPENSES_PUT, payload: {} });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};

export const expensesPendingCount = () => async (dispatch) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const pendingStatuses = ['PENDING', 'PREAPPROVE', 'APPROVE_1', 'APPROVE_2'];
    const results = await Promise.all(
      pendingStatuses.map((s) =>
        api.get(`${process.env.REACT_APP_API_URL}/expenses?status=${s}&dateStart=${today}&dateEnd=${today}&size=1&page=1`),),
    );
    const count = results.reduce((sum, { data, status }) => {
      if (status === 200) return sum + (data?.total ?? data?.rows?.length ?? 0);
      return sum;
    }, 0);
    dispatch({ type: EXPENSES_PENDING_COUNT, payload: count });
  } catch (error) {
    console.error(error);
  }
};

// นับรายการที่ยังรอตัดสินใจ (payment_approval_status=PENDING) ของ "วันนี้" — ใช้โชว์ badge ที่ submenu
// "อนุมัติการจ่ายเงิน" (ดู MainSidebar.js) นับเฉพาะ payment_approval_status ไม่กรอง status (workflow เบิก)
// เลย ให้ตรงกับขอบเขตของแท็บ "วันนี้" ใน PaymentApproval.js ที่ไม่กรอง status เหมือนกัน
export const expensesPaymentApprovalPendingCount = () => async (dispatch) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses?paymentApprovalStatuses=PENDING&dateStart=${today}&dateEnd=${today}&size=1&page=1`,
    );
    const count = status === 200 ? (data?.total ?? data?.rows?.length ?? 0) : 0;
    dispatch({ type: EXPENSES_PAYMENT_APPROVAL_PENDING_COUNT, payload: count });
  } catch (error) {
    console.error(error);
  }
};

// นับรายการที่ยังไม่ถูกตรวจสอบ (review_status=PENDING) ของ "วันนี้" — ต่างจาก
// expensesPaymentApprovalPendingCount ตรงที่ต้องกรอง statuses ด้วย (PENDING,APPROVE,PREPARE) เพราะ
// review_status เป็น flag อิสระจาก status จริง ไม่มีการรับประกันว่ารายการที่จ่ายเงินสำเร็จแล้ว
// (status=SUCCESS) จะถูกตรวจสอบไปด้วย (ต่างจาก payment_approval_status ที่ต้อง APPROVED ก่อนถึงจะเป็น
// SUCCESS ได้เสมอ — ดู expenses.service.js update()) ไม่กรองไว้ badge จะนับรวมรายการที่จ่ายจบไปแล้วด้วย
// ทั้งที่ไม่ใช่เรื่องด่วนที่ต้องรีบตรวจสอบอีกต่อไป
export const expensesReviewPendingCount = () => async (dispatch) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/expenses?statuses=PENDING,APPROVE,PREPARE&reviewStatuses=PENDING&dateStart=${today}&dateEnd=${today}&size=1&page=1`,
    );
    const count = status === 200 ? (data?.total ?? data?.rows?.length ?? 0) : 0;
    dispatch({ type: EXPENSES_REVIEW_PENDING_COUNT, payload: count });
  } catch (error) {
    console.error(error);
  }
};

export const expensesReset = () => async (dispatch) => {
  try {
    dispatch({ type: EXPENSES_RESET });
  } catch (error) {
    console.error(error);
    dispatch({ type: EXPENSES_ERROR });
    throw new Error(error);
  }
};
